import Text from "@/components/common/Typography/Text"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useIsMaxPeople } from "@/hooks/tour/useIsMaxPeople"

import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, InputNumber, InputNumberProps, Row } from "antd"
import { FC } from "react"

type InputPeopleProps = InputNumberProps & {
  label?: string,
  subLabel?: string,
  price?: number,
  value?: number,
}

const InputPeople: FC<InputPeopleProps> = ({ value = 0, label, subLabel, price = 0, min = 0, ...props }) => {
  const isMax = useIsMaxPeople()
  const { getFormatCurrency } = useTETranslation()

  return (
    <Card size='small'>
      <Row align='middle' justify='space-between'>
        <Col>
          <Row>
            <Text>
              {label}
            </Text>
          </Row>
          <Row>
            <Text className="te-text-small" type='secondary'>
              {subLabel}
            </Text>
          </Row>
        </Col>
        <Col>
          {value > 0 && (
            <Text style={{ fontWeight: 'bold' }} type='warning'>
              x {getFormatCurrency(price || 0)}
            </Text>
          )}
        </Col>
        <Col flex={"10rem"}>
          <Row wrap={false} align='middle'>

            <Col>
              <Button
                size='small'
                type='text'
                icon={<FontAwesomeIcon icon={faMinus} />}
                disabled={value <= (min as any)}
                onClick={() => {
                  props.onChange && props.onChange(value <= (min as any) ? min : value - 1)
                }}
              />
            </Col>
            <Col flex={1}>
              <InputNumber
                controls={false}
                className="tour-detail__input-people"
                value={value}
                size='small'
                variant='borderless'
                {...props}
                min={min}
                style={{ width: '100%', ...props.style }}
              />
            </Col>
            <Col>
              <Button
                size='small'
                type='text'
                icon={<FontAwesomeIcon icon={faPlus} />}
                disabled={isMax}
                onClick={() => {
                  props.onChange && props.onChange(isMax ? value : value + 1)
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default InputPeople